import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { FC } from 'react';
import { BrowserRouter } from 'react-router-dom';

import AppRoutes from '../../../src/components/route/AppRoutes';
import { ConfigProvider } from '../../../src/context/ConfigProvider';
import theme from '../../../src/theme/homepage-mui-theme';
import { COMPANY } from './assets/company';
import { FOOTER } from './assets/footer';
import { MENU } from './assets/menu';
import setAppRoutes from './set-app-routes';

setAppRoutes();

const App: FC = () => (
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <ConfigProvider value={{ company: COMPANY, footer: FOOTER, menu: MENU }}>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </ConfigProvider>
  </ThemeProvider>
);

export default App;
